import React, { useRef, useState } from 'react';

import { Popover, PopoverHandle } from 'DesignSystem2/Popover';
import { Row, RowGroup } from 'DesignSystem2/Row';
import { Spacing } from 'DesignSystem2/Theme';
import { SelectOptions } from 'models/constants';

interface SelectOptionsPopoverProps {
    children: React.ReactNode;
    options: SelectOptions[];
    onSelect: (value: string) => void;
}

const SelectOptionsPopover = ({ children, options, onSelect }: SelectOptionsPopoverProps): JSX.Element => {
    const popoverRef = useRef<PopoverHandle>(null);
    const [childrenWidth, setChildrenWidth] = useState<number>(200);

    return (
        <Popover
            popoverHandleRef={popoverRef}
            forceLeftAlign
            content={
                <div style={{ display: 'flex', width: childrenWidth, padding: `${Spacing(0.5)} ${Spacing(2)}` }}>
                    <RowGroup
                        style={{ width: '100%' }}
                        rows={options.map((option) => (
                            <Row
                                key={option.value}
                                labelText={option.label}
                                labelTextIsBold
                                onClick={() => {
                                    onSelect(option.value);
                                    popoverRef.current?.close();
                                }}
                                disabled={option.disabled}
                                tooltip={option.tooltip}
                            />
                        ))}
                    />
                </div>
            }
        >
            <div
                onClick={() => {
                    popoverRef.current?.open();
                }}
                ref={(element) => {
                    if (element) {
                        setChildrenWidth(element.getBoundingClientRect().width - 32);
                    }
                }}
            >
                {children}
            </div>
        </Popover>
    );
};

export default SelectOptionsPopover;
